/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import FolderSelectorModal from 'file-browser/FolderSelectorModal';
import * as FileUtil from 'folder-items/FileUtil';
import {isFixedPlateWellForNav} from 'samples/SampleUtil';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import APIUtil from 'util/APIUtil';
import * as ShortcutUtil from 'util/ShortcutUtil';

interface Props {
  className?: string;
  disabled?: boolean;
  files: Array<any>;
  finderId: string;
  tooltipTitle?: string;
  initialSelectedFolderId?: string;
  // This callback aims to track user clicks.
  onClickTracking?: () => void;
}

/**
 * Allows moving folder items, folders, and storables.
 */
class MoveButton extends React.Component<Props> {
  private handleOpenForMove = (): void => {
    this.props.onClickTracking?.();
    const folderContainables = this.props.files.filter((file) => APIUtil.isFolderContainable(file.id));
    const hasAllFolderContainables = folderContainables.length === this.props.files.length;
    const showInventory = hasAllFolderContainables;
    const showNotebook = hasAllFolderContainables;

    const allowNone = this.props.files.every((file) => {
      if (FileUtil.isInRegistry(file)) {
        return !BenchlingConfig.ENABLE_PROJECTS_REQUIRED_FOR_REGISTRY_FILES;
      } else if (APIUtil.isContainer(file.id)) {
        return !isFixedPlateWellForNav(file);
      } else if (APIUtil.isPlate(file.id) || APIUtil.isBox(file.id)) {
        return true;
      }
      return false;
    });

    FolderSelectorModal.openForMove(
      {
        allowNone,
        initialSelectedFolderId: this.props.initialSelectedFolderId,
        itemsToMove: this.props.files,
        showInventory,
        showNotebook,
        showRegistries: false,
      },
      (folderId) => {
        const parentFolderIds = ShortcutUtil.getParentFolderIdsWithShortcuts(
          folderContainables,
          this.props.finderId
        );
        const selectedIds = this.props.files.map((file) => file.id);
        FileBrowserActions.moveItemsWithDataMods(
          selectedIds,
          folderId,
          {parentFolderIds, hasRegisteredItems: this.props.files.some((file) => FileUtil.isInRegistry(file))},
          (fileId: any) => {
            const file = this.props.files.find((file) => file.id === fileId);
            return ShortcutUtil.shouldShowShortcut(file, this.props.finderId);
          }
        );
      }
    );
  };

  render(): JSX.Element {
    return (
      <Tooltip
        container="body"
        placement={TooltipPlacement.TOP}
        title={this.props.tooltipTitle ?? 'Move to folder'}
      >
        <Button
          buttonStyle={ButtonStyle.TERTIARY_WHITE}
          className={this.props.className}
          disabled={this.props.disabled}
          icon="move"
          onClick={this.handleOpenForMove}
          size={ButtonSize.SMALL}
        />
      </Tooltip>
    );
  }
}

export default MoveButton;
